// src/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  /* ─────────────────────────────────────
     Paleta de color corporativa
  ───────────────────────────────────── */
  palette: {
    primary: {
      main: "#FF6B00", // Naranja KWENERGY
      dark: "#CC5D00",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#004B8D", // Azul petróleo
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#FFFFFF",
      paper: "#F9F9F9",
    },
    text: {
      primary: "#333333",
      secondary: "#555555",
    },
  },

  /* ─────────────────────────────────────
     Tipografía
  ───────────────────────────────────── */
  typography: {
    /* Fuente base para todo lo que no se sobreescriba */
    fontFamily: '"Esoris", "Roboto", sans-serif',

    /* Encabezados en Ethos Nova (estilo normal) */
    h1: { fontFamily: '"Ethos Nova", sans-serif', fontWeight: 900 },
    h2: { fontFamily: '"Ethos Nova", sans-serif', fontWeight: 900 },
    h3: { fontFamily: '"Ethos Nova", sans-serif', fontWeight: 900 },
    h4: { fontFamily: '"Ethos Nova", sans-serif', fontWeight: 800 },
    h5: { fontFamily: '"Ethos Nova", sans-serif', fontWeight: 800 },
    h6: { fontFamily: '"Ethos Nova", sans-serif', fontWeight: 700 },

    /* Botones */
    button: { textTransform: "none", fontWeight: 700 },

    /* 🆕  Textos largos en Ethos Nova Italic  */
    body1: {
      fontFamily: '"Ethos Nova", sans-serif',
      fontStyle: "italic",
      fontWeight: 400,
    },
    body2: {
      fontFamily: '"Ethos Nova", sans-serif',
      fontStyle: "italic",
      fontWeight: 400,
    },
  },

  /* ─────────────────────────────────────
     Otros ajustes de UI
  ───────────────────────────────────── */
  shape: { borderRadius: 8 },

  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 8 },
        containedPrimary: { boxShadow: "0 4px 12px rgba(0,0,0,.12)" },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          color: "#333333",
          boxShadow: "none",
          borderBottom: "1px solid #EEEEEE",
        },
      },
    },
  },
});

export default theme;
